<div class="form-group" style="flex-grow: 0">
  <label for="travelMode">{{'Train markers' | translate}}:</label>
  <select
    class="custom-select custom-select-sm"
    [(ngModel)]="selectedMode"
    (change)="onSelectedModeChanged(selectedMode)">
    <option
      *ngFor="let mode of modes"
      [ngValue]="mode">{{ markerModeLabels[mode] | translate }}
    </option>
  </select>
</div>
